var chunkMapping = {
	"0": [
		4671
	],
	"3": [
		4071,
		4603
	],
	"79": [
		5105
	],
	"164": [
		5192
	],
	"165": [
		5193
	],
	"168": [
		5196
	],
	"169": [
		5197
	],
	"170": [
		5198
	],
	"171": [
		5199
	],
	"172": [
		5200
	],
	"173": [
		5201
	],
	"174": [
		5202
	],
	"175": [
		5203
	],
	"176": [
		5204
	],
	"177": [
		5205
	],
	"178": [
		5206
	],
	"179": [
		5207
	],
	"180": [
		5208
	],
	"181": [
		5209
	],
	"182": [
		5210
	],
	"183": [
		5211
	],
	"184": [
		5212
	],
	"185": [
		5213
	],
	"186": [
		5214
	],
	"187": [
		5215
	]
};
var idToExternalAndNameMapping = {
	"4071": [
		"default",
		"./nuorder-components",
		3687
	],
	"4603": [
		"default",
		"./helios-components",
		3687
	],
	"4671": [
		"default",
		"./Containers",
		3597
	],
	"5105": [
		"default",
		"./OrderlessInvoices",
		3597
	],
	"5192": [
		"default",
		"./AsyncEventTracker",
		3597
	],
	"5193": [
		"default",
		"./HostWrapper",
		3597
	],
	"5196": [
		"default",
		"./CheckoutV3",
		3597
	],
	"5197": [
		"default",
		"./CheckoutConfirmation",
		3597
	],
	"5198": [
		"default",
		"./ContactCreditCards",
		3597
	],
	"5199": [
		"default",
		"./AuditDialog",
		3597
	],
	"5200": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3597
	],
	"5201": [
		"default",
		"./InvoiceDialog",
		3597
	],
	"5202": [
		"default",
		"./PaymentDueModal",
		3597
	],
	"5203": [
		"default",
		"./PaymentModal",
		3597
	],
	"5204": [
		"default",
		"./PaymentHistory",
		3597
	],
	"5205": [
		"default",
		"./PaymentConfigurations",
		3597
	],
	"5206": [
		"default",
		"./PaymentPreferences",
		3597
	],
	"5207": [
		"default",
		"./ManagePaymentProcessing",
		3597
	],
	"5208": [
		"default",
		"./MobilePaymentsWrapper",
		3597
	],
	"5209": [
		"default",
		"./PayPage",
		3597
	],
	"5210": [
		"default",
		"./Challenge",
		3597
	],
	"5211": [
		"default",
		"./ManagePaymentMethods",
		3597
	],
	"5212": [
		"default",
		"./LightspeedReports",
		3597
	],
	"5213": [
		"default",
		"./ActivateLightspeedPayments",
		3597
	],
	"5214": [
		"default",
		"./MarketingLandingPage",
		3597
	],
	"5215": [
		"default",
		"./ShippingPromotionsListContainer",
		3597
	]
};
var idToRemoteMap = {
	"4071": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4603": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4671": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5105": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5199": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5200": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5201": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5202": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5203": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5204": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5205": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5206": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5207": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5208": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5209": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5210": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5211": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5212": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5213": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5214": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	],
	"5215": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3597
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}